/**
 * `IntersectionObserverEntry.isIntersecting` só chegou no **Chrome 58**.
 *
 * O IntersectionObserver em si existe desde o Chrome 51 — mas nas primeiras
 * versões a entry NÃO tinha `isIntersecting`, só `intersectionRatio`. Ou seja,
 * no Chrome 53 (webOS 4.x, o motor da TV do dono) `entry.isIntersecting` é
 * `undefined` — e todo `if (entry.isIntersecting)` vira SEMPRE falso, em
 * silêncio. Um lazy-load escrito assim simplesmente nunca carrega imagem
 * nenhuma, e um gate de montagem escrito assim nunca monta nada. Não dá erro:
 * só não funciona.
 *
 * O pacote de TV carrega o polyfill `intersection-observer` (via
 * `additionalLegacyPolyfills` no build legacy), e ele justamente enxerta um
 * getter de `isIntersecting` quando o IO nativo existe sem o campo. Mas
 * depender disso é frágil: amarra a corretude do componente à ordem e à
 * presença de um polyfill que só é injetado num perfil de build específico.
 *
 * `intersectionRatio` existe em TODAS as versões do IO. Este helper é a
 * checagem por CAPABILITY, correta em qualquer engine, com ou sem polyfill.
 *
 * Regressão real: pego rodando o bench dos trilhos no Chromium 53 de verdade
 * (rev 403380) — 0 imagens carregadas, inclusive as visíveis.
 */
export function isEntryVisible(entry: IntersectionObserverEntry): boolean {
  // `=== true` de propósito: em engine antigo o campo é `undefined`, e aí
  // caímos no ratio. Em engine moderno o campo manda (é o mais preciso, pois
  // considera rootMargin negativo etc).
  if (entry.isIntersecting === true) return true
  if (entry.isIntersecting === false) return false
  return entry.intersectionRatio > 0
}
